import { useState } from 'react'
import { PlusIcon } from '../../icons/plus';
import { EditIcon } from '../../icons/edit';
import { MinusIcon } from '../../icons/minusIcon';
import { DetailTable } from './detailRequirement';
import { normativa, optionsFormatter } from '../../../utils';
import { useAppSelector } from '../../../lib/redux/hooks';

interface Props {
    code: number
    title: string
    numOfDetails: number
    subTitle: string[]
    paragraph: string
    onEdit?: () => void
}

export function ListItem(props: Props) {
    const {code, title, numOfDetails, subTitle, paragraph, onEdit} = props
    const [expanded, setExpanded] = useState<boolean>(false)
    const requirementState = useAppSelector(state => state.PMRequirement)

    const handleSubtitles = (subs: string[]) => {
        if(subs === null) 
            return '';
        return subs.slice(0,-1)
                 .map(s => `${optionsFormatter(s, normativa)} - `) 
                  + optionsFormatter(subs[subs.length-1], normativa)!
    }

    return (
        <div className={`w-full h-auto flex gap-3 rounded-xl border p-4 bg-white ${expanded ? 'border-[#D6E4FF] shadow-[0_6px_12px_rgba(16,24,40,0.08)]' : 'border-neutral-200 shadow-sm'}`}>
            <div className='flex-[48px] max-w-16 pt-[2px] text-left'>
                <span className='text-xs font-bold leading-5 text-neutral-500 text-center'>{code < 10 ? `0${code}` : code}</span>
            </div>

            <div className='flex-[90%] flex flex-col items-start'>
                <div className='flex items-center gap-[10px]'>
                    <span className='text-base font-semibold leading-[22px] text-left text-[#182B2E]'>{title}</span>
                    <span className='inline-flex min-w-6 h-6 items-center justify-center rounded-full text-xs font-bold bg-[#E7F0FF] text-[#1E40AF] px-2'>{numOfDetails}</span>
                </div>

                <div className='mt-1.5 flex items-center flex-wrap gap-1.5'>
                    <span className='text-[13px] font-medium leading-4 text-left text-neutral-500'>Norma di riferimento:</span>
                    <span className='text-[13px] font-semibold leading-4 text-left text-[#37565A]'>{handleSubtitles(subTitle)}</span>
                </div>

                <div className='max-w-[1000px] break-words pb-1'>
                    <span className='text-sm font-normal leading-5 text-left text-gray-600'>{paragraph}</span>
                </div>

                {
                    expanded && (
                        <DetailTable
                            requirementId={String(code)}
                            details={requirementState.requirementDetails
                                .filter(d => Number(d.requirementId) === code)}
                        />
                    )
                }
            </div>

            <div className='flex-[5%] flex items-start justify-end'>
                <div className='flex flex-row gap-2'>
                    <button className='w-8 h-8 border border-neutral-200 rounded-lg inline-flex items-center justify-center bg-white hover:bg-slate-50 hover:border-neutral-300 transition-colors duration-200' onClick={() => onEdit && onEdit()}>
                        <EditIcon color='orange' size={20} />
                    </button>
                    {
                        !expanded ? (
                            <button className='w-8 h-8 border border-neutral-200 rounded-lg inline-flex items-center justify-center bg-white hover:bg-slate-50 hover:border-neutral-300 transition-colors duration-200' onClick={() => setExpanded(true)}>
                                <PlusIcon color='orange' size={20} />
                            </button>
                        ) : (
                            <button className='w-8 h-8 border border-neutral-200 rounded-lg inline-flex items-center justify-center bg-white hover:bg-slate-50 hover:border-neutral-300 transition-colors duration-200' onClick={() => setExpanded(false)}>
                                <MinusIcon color='orange'/>
                            </button>
                        )
                    }
                </div>
            </div>
        </div>
    )
}